// extracted by mini-css-extract-plugin
export default {"fileInput":"FileUploader_fileInput__-dTA1","label":"FileUploader_label__mKEZO"};